module.exports = __webpack_public_path__ + "img/arleymendez.5e3d51ce.jpg";